const config = {
    development: {
        apiUrl: 'http://127.0.0.1:5000',
    },
    production: {
        apiUrl: '',
    },
}

export default config[process.env.NODE_ENV || 'development']